import { render, staticRenderFns } from "./fpxmDetail.vue?vue&type=template&id=15d21ac1&scoped=true&"
import script from "./fpxmDetail.vue?vue&type=script&lang=js&"
export * from "./fpxmDetail.vue?vue&type=script&lang=js&"
import style0 from "./fpxmDetail.vue?vue&type=style&index=0&id=15d21ac1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d21ac1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d21ac1')) {
      api.createRecord('15d21ac1', component.options)
    } else {
      api.reload('15d21ac1', component.options)
    }
    module.hot.accept("./fpxmDetail.vue?vue&type=template&id=15d21ac1&scoped=true&", function () {
      api.rerender('15d21ac1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/granary/map/util/fpxmDetail.vue"
export default component.exports